import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

import ButtonSecondary from 'common/ButtonSecondary';

export default function Navigation({ next, prev, today }) {
    const chevronButtonStyle = {
        width: '36px',
        height: '36px',
        minWidth: '36px',
        minHeight: '36px',
        padding: '0 !important',
        flexShrink: 0,
    };

    return (
        <div className={'flex space-x-2'}>
            <ButtonSecondary 
                onClick={prev} 
                className="rounded-full flex items-center justify-center"
                style={chevronButtonStyle}
            >
                <KeyboardArrowLeftIcon fontSize="medium" />
            </ButtonSecondary>

            <ButtonSecondary onClick={today}>Today</ButtonSecondary>

            <ButtonSecondary 
                onClick={next} 
                className="rounded-full flex items-center justify-center"
                style={chevronButtonStyle}
            >
                <ChevronRightIcon fontSize="medium" />
            </ButtonSecondary>
        </div>
    );
}
